import React, { useEffect, useState } from "react";
import Reveal from "../components/Reveal";
import OffersSection from "../components/OffersSection";
import BookingModal from "../components/BookingModal";
import PageSeo from "../components/PageSeo";
import { fetchOffers } from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { useSettings } from "../context/SiteSettingsContext";

export default function OffersPage() {
  const { t, lang } = useLang();
  const settings = useSettings();
  const [offers, setOffers] = useState([]);
  const [bookOpen, setBookOpen] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchOffers().then(setOffers).catch(() => {}); }, []);

  const seoTitle = lang === "en" ? settings.offers_meta_title_en : settings.offers_meta_title_it;
  const seoDesc = lang === "en" ? settings.offers_meta_desc_en : settings.offers_meta_desc_it;

  return (
    <div className="pt-32 bg-[#09090b] min-h-screen" data-testid="offers-page">
      <PageSeo title={seoTitle} description={seoDesc} pathIt="/it/offerte" pathEn="/en/offers" />
      <div className="container-x pb-8">
        <Reveal>
          <div className="overline mb-4">{t.offers.overline}</div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1] max-w-3xl">
            {t.offers.title.split("\n").map((l, i) => (<span key={l || `op-line-${i}`} className="block">{l}</span>))}
          </h1>
          <p className="mt-6 text-white/70 max-w-xl">{t.offers.subtitle}</p>
        </Reveal>
      </div>
      <OffersSection offers={offers} onBook={() => setBookOpen(true)} />
      <BookingModal open={bookOpen} onOpenChange={setBookOpen} />
    </div>
  );
}
